import { render, staticRenderFns } from "./AnonymousHeader.vue?vue&type=template&id=61e36eaa"
import script from "./AnonymousHeader.vue?vue&type=script&lang=js"
export * from "./AnonymousHeader.vue?vue&type=script&lang=js"
import style0 from "./AnonymousHeader.vue?vue&type=style&index=0&id=61e36eaa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports